<h3>{{ selectedConsumer?.name | titlecase }}</h3>
@if (selectedConsumer && selectedLocation) {
  <h4>{{ selectedLocation.name | titlecase }}</h4>
}
<aside>
  @if (selectedConsumer) {
    <button
      [attr.data-testid]="'add_button'"
      class="icon"
      mat-icon-button
      matTooltip="Add Submenu"
      (click)="add.emit()"
      >
      <mat-icon class="icon">add</mat-icon>
    </button>
  }
</aside>
